module.exports = __webpack_public_path__ + "img/tractorUnitFrontLeft.33c39fa2.svg";